import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';

const Fieldgroup = ({ id, label, help, validationState, ...props }) => (
  <FormGroup controlId={id} validationState={validationState}>
    <ControlLabel>{label}</ControlLabel>
    <FormControl {...props} />
    {help && <HelpBlock>{help}</HelpBlock>}
  </FormGroup>
);

Fieldgroup.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  help: PropTypes.string,
  validationState: PropTypes.string,
};

Fieldgroup.defaultProps = {
  id: '',
  label: '',
  help: '',
  validationState: '',
};

export default Fieldgroup;



// WEBPACK FOOTER //
// ./src/components/FieldGroup.js